import { SUPPORTED_LANGUAGES, normalizeLocale, LOCALE_COOKIE_NAME } from './types';

/**
 * Set locale cookie client-side
 * Handles domain for cross-subdomain support
 */
export function setLocaleCookieClient(locale: string): void {
  if (typeof document === 'undefined') {
    return;
  }

  // Validate locale
  const normalized = normalizeLocale(locale);
  if (!SUPPORTED_LANGUAGES.some(lang => lang.code === normalized)) {
    return; // Don't set invalid locale
  }

  // Determine cookie domain
  let cookieDomain: string | undefined;
  const hostname = window.location.hostname;
  
  if (hostname && !hostname.includes('localhost') && !hostname.match(/^\d+\.\d+\.\d+\.\d+/)) {
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      // Use root domain with leading dot for cross-subdomain support
      const rootDomain = parts.slice(-2).join('.');
      cookieDomain = `.${rootDomain}`;
    }
  }
  // For localhost, don't set domain (browsers handle it automatically)

  // Build cookie string
  const cookieOptions: string[] = [
    `${LOCALE_COOKIE_NAME}=${normalized}`,
    'Path=/',
    'Max-Age=31536000', // 1 year
    'SameSite=Lax',
  ];

  if (cookieDomain) {
    cookieOptions.push(`Domain=${cookieDomain}`);
  }

  // Add Secure flag in production
  if (process.env.NODE_ENV === 'production') {
    cookieOptions.push('Secure');
  }

  // Set cookie
  document.cookie = cookieOptions.join('; ');
}

/**
 * Get locale from cookie client-side
 */
export function getLocaleFromCookieClient(): string | null {
  if (typeof document === 'undefined') {
    return null;
  }

  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === LOCALE_COOKIE_NAME && value) {
      return normalizeLocale(value);
    }
  }

  return null;
}
